//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const SEO_ADMIN_API_BASE_URL = new InjectionToken<string>('SEO_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminSeoPagesClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(SEO_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(request: AdminSeoPageSearchRequestDto): Observable<AdminSeoPageSearchResultDto> {
        let url_ = this.baseUrl + "/admin/seo-pages/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminSeoPageSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminSeoPageSearchResultDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AdminSeoPageSearchResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSeoPageSearchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.Search');
            }));
        }
        return _observableOf(null as any);
    }

    getSelector(domain: AdminSeoDomain, selectorId: number): Observable<AdminSeoSelectorDetailsDto> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminSeoSelectorDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminSeoSelectorDetailsDto>;
        }));
    }

    protected processGetSelector(response: HttpResponseBase): Observable<AdminSeoSelectorDetailsDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSeoSelectorDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.GetSelector');
            }));
        }
        return _observableOf(null as any);
    }

    editSelector(domain: AdminSeoDomain, selectorId: number, selector: AdminSeoSelectorSaveDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selector);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.EditSelector');
            }));
        }
        return _observableOf(null as any);
    }

    deleteSelector(domain: AdminSeoDomain, selectorId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.DeleteSelector');
            }));
        }
        return _observableOf(null as any);
    }

    getCatalog(domain: AdminSeoDomain, catalogId: number): Observable<AdminSeoCatalogDetailsDto> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminSeoCatalogDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminSeoCatalogDetailsDto>;
        }));
    }

    protected processGetCatalog(response: HttpResponseBase): Observable<AdminSeoCatalogDetailsDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSeoCatalogDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.GetCatalog');
            }));
        }
        return _observableOf(null as any);
    }

    editCatalog(domain: AdminSeoDomain, catalogId: number, catalog: AdminSeoCatalogSaveDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalog);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.EditCatalog');
            }));
        }
        return _observableOf(null as any);
    }

    deleteCatalog(domain: AdminSeoDomain, catalogId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.DeleteCatalog');
            }));
        }
        return _observableOf(null as any);
    }

    getCatalogSelectors(domain: AdminSeoDomain, catalogId: number): Observable<AdminSeoCatalogSelectorsDto> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}/selectors";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogSelectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogSelectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminSeoCatalogSelectorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminSeoCatalogSelectorsDto>;
        }));
    }

    protected processGetCatalogSelectors(response: HttpResponseBase): Observable<AdminSeoCatalogSelectorsDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSeoCatalogSelectorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.GetCatalogSelectors');
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(domain: AdminSeoDomain, kind: AdminSeoEntityRoute, entityId: number): Observable<SeoChangeEntryDto[]> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/{kind}/{entityId}/history";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined.");
        url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeoChangeEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeoChangeEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<SeoChangeEntryDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeoChangeEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.GetHistory');
            }));
        }
        return _observableOf(null as any);
    }

    duplicatesCheck(domain: AdminSeoDomain, request: AdminSeoDuplicatesCheckRequestDto): Observable<SelectorSearchResultDto[]> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/duplicates-check";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicatesCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicatesCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectorSearchResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectorSearchResultDto[]>;
        }));
    }

    protected processDuplicatesCheck(response: HttpResponseBase): Observable<SelectorSearchResultDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectorSearchResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.DuplicatesCheck');
            }));
        }
        return _observableOf(null as any);
    }

    createSelector(domain: AdminSeoDomain, selector: AdminSeoSelectorSaveDto): Observable<number> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selector);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSelector(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.CreateSelector');
            }));
        }
        return _observableOf(null as any);
    }

    createCatalog(domain: AdminSeoDomain, catalog: AdminSeoCatalogSaveDto): Observable<number> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalog);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCatalog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.CreateCatalog');
            }));
        }
        return _observableOf(null as any);
    }

    publishSelector(domain: AdminSeoDomain, selectorId: number, url: string | null): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}/publish?";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        if (url === undefined)
            throw new globalThis.Error("The parameter 'url' must be defined.");
        else if(url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.PublishSelector');
            }));
        }
        return _observableOf(null as any);
    }

    publishCatalog(domain: AdminSeoDomain, catalogId: number, url: string | null): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}/publish?";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        if (url === undefined)
            throw new globalThis.Error("The parameter 'url' must be defined.");
        else if(url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.PublishCatalog');
            }));
        }
        return _observableOf(null as any);
    }

    disableSelector(domain: AdminSeoDomain, selectorId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}/disable";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.DisableSelector');
            }));
        }
        return _observableOf(null as any);
    }

    activateSelector(domain: AdminSeoDomain, selectorId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}/activate";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.ActivateSelector');
            }));
        }
        return _observableOf(null as any);
    }

    restoreSelector(domain: AdminSeoDomain, selectorId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/selectors/{selectorId}/restore";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (selectorId === undefined || selectorId === null)
            throw new globalThis.Error("The parameter 'selectorId' must be defined.");
        url_ = url_.replace("{selectorId}", encodeURIComponent("" + selectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreSelector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreSelector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreSelector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.RestoreSelector');
            }));
        }
        return _observableOf(null as any);
    }

    restoreCatalog(domain: AdminSeoDomain, catalogId: number): Observable<void> {
        let url_ = this.baseUrl + "/admin/seo-pages/{domain}/catalogs/{catalogId}/restore";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (catalogId === undefined || catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminSeoPagesClient.RestoreCatalog');
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminSeoPageSearchResultDto implements IAdminSeoPageSearchResultDto {
    items!: AdminSeoPageListItemDto[];
    total!: number;

    constructor(data?: IAdminSeoPageSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminSeoPageListItemDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AdminSeoPageSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoPageSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IAdminSeoPageSearchResultDto {
    items: AdminSeoPageListItemDto[];
    total: number;
}

export class AdminSeoPageListItemDto implements IAdminSeoPageListItemDto {
    id!: number;
    entityKind!: SeoEntityKind;
    domain!: AdminSeoDomain;
    kind!: AdminSeoPageKind;
    workType!: WorkType;
    cityId!: number | undefined;
    cityName!: string | undefined;
    url!: string | undefined;
    isDraft!: boolean;
    isDisabled!: boolean;
    isDeleted!: boolean;
    isModified!: boolean;
    metaTitle!: string | undefined;
    searchResultsCount!: number | undefined;
    activeSelectorsCount!: number | undefined;
    disabledSelectorsCount!: number | undefined;
    createDate!: Date;
    updateDate!: Date | undefined;
    lastModifiedBy!: string | undefined;
    lastModifiedByName!: string | undefined;

    constructor(data?: IAdminSeoPageListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityKind = _data["entityKind"];
            this.domain = _data["domain"];
            this.kind = _data["kind"];
            this.workType = _data["workType"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.url = _data["url"];
            this.isDraft = _data["isDraft"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.isModified = _data["isModified"];
            this.metaTitle = _data["metaTitle"];
            this.searchResultsCount = _data["searchResultsCount"];
            this.activeSelectorsCount = _data["activeSelectorsCount"];
            this.disabledSelectorsCount = _data["disabledSelectorsCount"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedByName = _data["lastModifiedByName"];
        }
    }

    static fromJS(data: any): AdminSeoPageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoPageListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityKind"] = this.entityKind;
        data["domain"] = this.domain;
        data["kind"] = this.kind;
        data["workType"] = this.workType;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["url"] = this.url;
        data["isDraft"] = this.isDraft;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["isModified"] = this.isModified;
        data["metaTitle"] = this.metaTitle;
        data["searchResultsCount"] = this.searchResultsCount;
        data["activeSelectorsCount"] = this.activeSelectorsCount;
        data["disabledSelectorsCount"] = this.disabledSelectorsCount;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedByName"] = this.lastModifiedByName;
        return data;
    }
}

export interface IAdminSeoPageListItemDto {
    id: number;
    entityKind: SeoEntityKind;
    domain: AdminSeoDomain;
    kind: AdminSeoPageKind;
    workType: WorkType;
    cityId: number | undefined;
    cityName: string | undefined;
    url: string | undefined;
    isDraft: boolean;
    isDisabled: boolean;
    isDeleted: boolean;
    isModified: boolean;
    metaTitle: string | undefined;
    searchResultsCount: number | undefined;
    activeSelectorsCount: number | undefined;
    disabledSelectorsCount: number | undefined;
    createDate: Date;
    updateDate: Date | undefined;
    lastModifiedBy: string | undefined;
    lastModifiedByName: string | undefined;
}

export enum SeoEntityKind {
    Undefined = "Undefined",
    ResumeSelector = "ResumeSelector",
    VacancySelector = "VacancySelector",
    ResumeCatalog = "ResumeCatalog",
    VacancyCatalog = "VacancyCatalog",
}

export enum AdminSeoDomain {
    Undefined = "Undefined",
    Resumes = "Resumes",
    Vacancies = "Vacancies",
}

export enum AdminSeoPageKind {
    Undefined = "Undefined",
    Selector = "Selector",
    Catalog = "Catalog",
}

export enum WorkType {
    Undefined = "Undefined",
    Nanny = "Nanny",
    Nurse = "Nurse",
    Housekeeper = "Housekeeper",
    PetCare = "PetCare",
    Tutor = "Tutor",
    Cook = "Cook",
    Driver = "Driver",
}

export class AdminSeoPageSearchRequestDto implements IAdminSeoPageSearchRequestDto {
    domain!: AdminSeoDomain | undefined;
    kind!: AdminSeoPageKind | undefined;
    workType!: WorkType | undefined;
    statuses!: AdminSeoPageStatus[] | undefined;
    url!: string | undefined;
    metaTitle!: string | undefined;
    cityId!: number | undefined;
    catalogId!: number | undefined;
    page!: number;
    pageSize!: number;

    constructor(data?: IAdminSeoPageSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.kind = _data["kind"];
            this.workType = _data["workType"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.url = _data["url"];
            this.metaTitle = _data["metaTitle"];
            this.cityId = _data["cityId"];
            this.catalogId = _data["catalogId"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AdminSeoPageSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoPageSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["kind"] = this.kind;
        data["workType"] = this.workType;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["url"] = this.url;
        data["metaTitle"] = this.metaTitle;
        data["cityId"] = this.cityId;
        data["catalogId"] = this.catalogId;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAdminSeoPageSearchRequestDto {
    domain: AdminSeoDomain | undefined;
    kind: AdminSeoPageKind | undefined;
    workType: WorkType | undefined;
    statuses: AdminSeoPageStatus[] | undefined;
    url: string | undefined;
    metaTitle: string | undefined;
    cityId: number | undefined;
    catalogId: number | undefined;
    page: number;
    pageSize: number;
}

export enum AdminSeoPageStatus {
    Undefined = "Undefined",
    Draft = "Draft",
    Published = "Published",
    Disabled = "Disabled",
    Deleted = "Deleted",
}

export abstract class AdminSeoPageDetailsBaseDto implements IAdminSeoPageDetailsBaseDto {
    id!: number;
    workType!: WorkType;
    url!: string | undefined;
    oldUrl!: string | undefined;
    data!: SeoData;
    condition!: AdminSeoConditionDto;
    isPriority!: boolean;
    priorityOrder!: number;
    countLinksToIssue!: number;
    isLinkingDisabled!: boolean;
    isDisabled!: boolean;
    isDraft!: boolean;
    isDeleted!: boolean;
    medianHourlySalaryEnabled!: boolean;
    createDate!: Date;
    updateDate!: Date | undefined;
    lastModifiedBy!: string | undefined;
    lastModifiedByName!: string | undefined;

    constructor(data?: IAdminSeoPageDetailsBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = new SeoData();
            this.condition = new AdminSeoConditionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workType = _data["workType"];
            this.url = _data["url"];
            this.oldUrl = _data["oldUrl"];
            this.data = _data["data"] ? SeoData.fromJS(_data["data"]) : new SeoData();
            this.condition = _data["condition"] ? AdminSeoConditionDto.fromJS(_data["condition"]) : new AdminSeoConditionDto();
            this.isPriority = _data["isPriority"];
            this.priorityOrder = _data["priorityOrder"];
            this.countLinksToIssue = _data["countLinksToIssue"];
            this.isLinkingDisabled = _data["isLinkingDisabled"];
            this.isDisabled = _data["isDisabled"];
            this.isDraft = _data["isDraft"];
            this.isDeleted = _data["isDeleted"];
            this.medianHourlySalaryEnabled = _data["medianHourlySalaryEnabled"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedByName = _data["lastModifiedByName"];
        }
    }

    static fromJS(data: any): AdminSeoPageDetailsBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AdminSeoPageDetailsBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workType"] = this.workType;
        data["url"] = this.url;
        data["oldUrl"] = this.oldUrl;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["isPriority"] = this.isPriority;
        data["priorityOrder"] = this.priorityOrder;
        data["countLinksToIssue"] = this.countLinksToIssue;
        data["isLinkingDisabled"] = this.isLinkingDisabled;
        data["isDisabled"] = this.isDisabled;
        data["isDraft"] = this.isDraft;
        data["isDeleted"] = this.isDeleted;
        data["medianHourlySalaryEnabled"] = this.medianHourlySalaryEnabled;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedByName"] = this.lastModifiedByName;
        return data;
    }
}

export interface IAdminSeoPageDetailsBaseDto {
    id: number;
    workType: WorkType;
    url: string | undefined;
    oldUrl: string | undefined;
    data: SeoData;
    condition: AdminSeoConditionDto;
    isPriority: boolean;
    priorityOrder: number;
    countLinksToIssue: number;
    isLinkingDisabled: boolean;
    isDisabled: boolean;
    isDraft: boolean;
    isDeleted: boolean;
    medianHourlySalaryEnabled: boolean;
    createDate: Date;
    updateDate: Date | undefined;
    lastModifiedBy: string | undefined;
    lastModifiedByName: string | undefined;
}

export class AdminSeoSelectorDetailsDto extends AdminSeoPageDetailsBaseDto implements IAdminSeoSelectorDetailsDto {
    cityId!: number;
    cityName!: string | undefined;
    catalogId!: number | undefined;
    isModified!: boolean;
    searchResultsCount!: number;

    constructor(data?: IAdminSeoSelectorDetailsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.catalogId = _data["catalogId"];
            this.isModified = _data["isModified"];
            this.searchResultsCount = _data["searchResultsCount"];
        }
    }

    static override fromJS(data: any): AdminSeoSelectorDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoSelectorDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["catalogId"] = this.catalogId;
        data["isModified"] = this.isModified;
        data["searchResultsCount"] = this.searchResultsCount;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminSeoSelectorDetailsDto extends IAdminSeoPageDetailsBaseDto {
    cityId: number;
    cityName: string | undefined;
    catalogId: number | undefined;
    isModified: boolean;
    searchResultsCount: number;
}

export class SeoData implements ISeoData {
    metaTitle!: string | undefined;
    metaTitleTemplate!: string | undefined;
    metaDescription!: string | undefined;
    metaDescriptionTemplate!: string | undefined;
    metaKeywords!: string | undefined;
    metaKeywordsTemplate!: string | undefined;
    texts!: SeoText[] | undefined;
    seoMainSubTitle!: string | undefined;
    seoMainSubTitleTemplate!: string | undefined;
    seoH1!: string | undefined;
    seoH1Template!: string | undefined;
    templateId!: number;
    nameInBreadcrumbs!: string | undefined;
    nameInBreadcrumbsTemplate!: string | undefined;
    nameInLinkSystem!: string | undefined;
    nameInLinkSystemTemplate!: string | undefined;
    pageNumber!: number | undefined;
    pageSize!: number;
    previewSeoTextLength!: number;
    isPaginationDisabled!: boolean;
    seoValuableSearchTextIndicesJson!: string | undefined;

    constructor(data?: ISeoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaTitle = _data["metaTitle"];
            this.metaTitleTemplate = _data["metaTitleTemplate"];
            this.metaDescription = _data["metaDescription"];
            this.metaDescriptionTemplate = _data["metaDescriptionTemplate"];
            this.metaKeywords = _data["metaKeywords"];
            this.metaKeywordsTemplate = _data["metaKeywordsTemplate"];
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(SeoText.fromJS(item));
            }
            this.seoMainSubTitle = _data["seoMainSubTitle"];
            this.seoMainSubTitleTemplate = _data["seoMainSubTitleTemplate"];
            this.seoH1 = _data["seoH1"];
            this.seoH1Template = _data["seoH1Template"];
            this.templateId = _data["templateId"];
            this.nameInBreadcrumbs = _data["nameInBreadcrumbs"];
            this.nameInBreadcrumbsTemplate = _data["nameInBreadcrumbsTemplate"];
            this.nameInLinkSystem = _data["nameInLinkSystem"];
            this.nameInLinkSystemTemplate = _data["nameInLinkSystemTemplate"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.previewSeoTextLength = _data["previewSeoTextLength"];
            this.isPaginationDisabled = _data["isPaginationDisabled"];
            this.seoValuableSearchTextIndicesJson = _data["seoValuableSearchTextIndicesJson"];
        }
    }

    static fromJS(data: any): SeoData {
        data = typeof data === 'object' ? data : {};
        let result = new SeoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaTitle"] = this.metaTitle;
        data["metaTitleTemplate"] = this.metaTitleTemplate;
        data["metaDescription"] = this.metaDescription;
        data["metaDescriptionTemplate"] = this.metaDescriptionTemplate;
        data["metaKeywords"] = this.metaKeywords;
        data["metaKeywordsTemplate"] = this.metaKeywordsTemplate;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item ? item.toJSON() : undefined as any);
        }
        data["seoMainSubTitle"] = this.seoMainSubTitle;
        data["seoMainSubTitleTemplate"] = this.seoMainSubTitleTemplate;
        data["seoH1"] = this.seoH1;
        data["seoH1Template"] = this.seoH1Template;
        data["templateId"] = this.templateId;
        data["nameInBreadcrumbs"] = this.nameInBreadcrumbs;
        data["nameInBreadcrumbsTemplate"] = this.nameInBreadcrumbsTemplate;
        data["nameInLinkSystem"] = this.nameInLinkSystem;
        data["nameInLinkSystemTemplate"] = this.nameInLinkSystemTemplate;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["previewSeoTextLength"] = this.previewSeoTextLength;
        data["isPaginationDisabled"] = this.isPaginationDisabled;
        data["seoValuableSearchTextIndicesJson"] = this.seoValuableSearchTextIndicesJson;
        return data;
    }
}

export interface ISeoData {
    metaTitle: string | undefined;
    metaTitleTemplate: string | undefined;
    metaDescription: string | undefined;
    metaDescriptionTemplate: string | undefined;
    metaKeywords: string | undefined;
    metaKeywordsTemplate: string | undefined;
    texts: SeoText[] | undefined;
    seoMainSubTitle: string | undefined;
    seoMainSubTitleTemplate: string | undefined;
    seoH1: string | undefined;
    seoH1Template: string | undefined;
    templateId: number;
    nameInBreadcrumbs: string | undefined;
    nameInBreadcrumbsTemplate: string | undefined;
    nameInLinkSystem: string | undefined;
    nameInLinkSystemTemplate: string | undefined;
    pageNumber: number | undefined;
    pageSize: number;
    previewSeoTextLength: number;
    isPaginationDisabled: boolean;
    seoValuableSearchTextIndicesJson: string | undefined;
}

export class SeoText implements ISeoText {
    id!: number;
    order!: number;
    position!: number | undefined;
    title!: string | undefined;
    titleTemplate!: string | undefined;
    value!: string | undefined;
    valueTemplate!: string | undefined;

    constructor(data?: ISeoText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.position = _data["position"];
            this.title = _data["title"];
            this.titleTemplate = _data["titleTemplate"];
            this.value = _data["value"];
            this.valueTemplate = _data["valueTemplate"];
        }
    }

    static fromJS(data: any): SeoText {
        data = typeof data === 'object' ? data : {};
        let result = new SeoText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["position"] = this.position;
        data["title"] = this.title;
        data["titleTemplate"] = this.titleTemplate;
        data["value"] = this.value;
        data["valueTemplate"] = this.valueTemplate;
        return data;
    }
}

export interface ISeoText {
    id: number;
    order: number;
    position: number | undefined;
    title: string | undefined;
    titleTemplate: string | undefined;
    value: string | undefined;
    valueTemplate: string | undefined;
}

export class AdminSeoConditionDto implements IAdminSeoConditionDto {
    workType!: WorkType;
    searchTexts!: string[] | undefined;
    fuzzySearchStrictMode!: boolean | undefined;
    salary!: number | undefined;
    salaryConditionType!: SalaryConditionType | undefined;
    sortOrder!: SortOrder | undefined;
    partsOfDay!: number[] | undefined;
    searchRadius!: number | undefined;
    originLat!: number | undefined;
    originLng!: number | undefined;
    hasAudioMessage!: boolean | undefined;
    yearExperience!: number | undefined;
    workStartDate!: Date | undefined;
    workingTerms!: number[] | undefined;
    ageGroups!: number[] | undefined;
    notSmoke!: boolean | undefined;
    canSwimWell!: boolean | undefined;
    isKashrut!: boolean | undefined;
    requireLiveInCaregiverProgram!: boolean | undefined;
    canRelocate!: boolean | undefined;
    withPhoto!: boolean | undefined;
    rightToWork!: boolean | undefined;
    languages!: number[] | undefined;
    policeCheck!: boolean | undefined;
    resumeSortBy!: ResumeSortBy | undefined;
    canWorkUnderVideoSurveillance!: boolean | undefined;
    hasMedicalBook!: boolean | undefined;
    hasMedicalTests!: boolean | undefined;
    hasPsychiatricCertificate!: boolean | undefined;
    hasNarcologicalCertificate!: boolean | undefined;
    maritalStatus!: number[] | undefined;
    dontShowFromAgency!: boolean | undefined;
    vacancySortBy!: VacancySortBy | undefined;
    liveInOuts!: number[] | undefined;
    employments!: number[] | undefined;
    workingSkills!: number[] | undefined;
    workplaces!: number[] | undefined;
    educations!: number[] | undefined;
    hasDriverLicense!: boolean | undefined;
    hasCar!: boolean | undefined;
    nannySubTypes!: number[] | undefined;
    hasChildren!: boolean | undefined;
    childrenCounts!: number[] | undefined;
    workingExperienceAges!: number[] | undefined;
    canWorkWithDisabled!: boolean | undefined;
    childrenCount!: number | undefined;
    nurseSubTypes!: number[] | undefined;
    diagnoses!: number[] | undefined;
    diagnosesExperience!: number[] | undefined;
    housekeeperSubTypes!: number[] | undefined;
    cleanTools!: number[] | undefined;
    petCareSubTypes!: number[] | undefined;
    animalTypes!: number[] | undefined;
    tutorSubTypes!: number[] | undefined;
    teachingAges!: number[] | undefined;
    anyTeachingMusics!: boolean | undefined;
    anyTeachingPhysicalCultures!: boolean | undefined;
    anyTeachingSubjects!: boolean | undefined;
    anyTeachingArts!: boolean | undefined;
    anyTeachingLanguages!: boolean | undefined;
    teachingMusics!: number[] | undefined;
    teachingPhysicalCultures!: number[] | undefined;
    teachingSubjects!: number[] | undefined;
    teachingArts!: number[] | undefined;
    teachingLanguages!: number[] | undefined;
    cookSubTypes!: number[] | undefined;
    cookDuties!: number[] | undefined;
    cookKitchens!: number[] | undefined;
    cookFeatures!: number[] | undefined;
    cookEducations!: number[] | undefined;
    driverSubTypes!: number[] | undefined;
    carUsageOptions!: number[] | undefined;
    babyCarSeatOptions!: number[] | undefined;
    driverNannyDuties!: number[] | undefined;
    driverDuties!: number[] | undefined;
    driverEducations!: number[] | undefined;
    carTypes!: number[] | undefined;

    constructor(data?: IAdminSeoConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workType = _data["workType"];
            if (Array.isArray(_data["searchTexts"])) {
                this.searchTexts = [] as any;
                for (let item of _data["searchTexts"])
                    this.searchTexts!.push(item);
            }
            this.fuzzySearchStrictMode = _data["fuzzySearchStrictMode"];
            this.salary = _data["salary"];
            this.salaryConditionType = _data["salaryConditionType"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["partsOfDay"])) {
                this.partsOfDay = [] as any;
                for (let item of _data["partsOfDay"])
                    this.partsOfDay!.push(item);
            }
            this.searchRadius = _data["searchRadius"];
            this.originLat = _data["originLat"];
            this.originLng = _data["originLng"];
            this.hasAudioMessage = _data["hasAudioMessage"];
            this.yearExperience = _data["yearExperience"];
            this.workStartDate = _data["workStartDate"] ? new Date(_data["workStartDate"].toString()) : undefined as any;
            if (Array.isArray(_data["workingTerms"])) {
                this.workingTerms = [] as any;
                for (let item of _data["workingTerms"])
                    this.workingTerms!.push(item);
            }
            if (Array.isArray(_data["ageGroups"])) {
                this.ageGroups = [] as any;
                for (let item of _data["ageGroups"])
                    this.ageGroups!.push(item);
            }
            this.notSmoke = _data["notSmoke"];
            this.canSwimWell = _data["canSwimWell"];
            this.isKashrut = _data["isKashrut"];
            this.requireLiveInCaregiverProgram = _data["requireLiveInCaregiverProgram"];
            this.canRelocate = _data["canRelocate"];
            this.withPhoto = _data["withPhoto"];
            this.rightToWork = _data["rightToWork"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.policeCheck = _data["policeCheck"];
            this.resumeSortBy = _data["resumeSortBy"];
            this.canWorkUnderVideoSurveillance = _data["canWorkUnderVideoSurveillance"];
            this.hasMedicalBook = _data["hasMedicalBook"];
            this.hasMedicalTests = _data["hasMedicalTests"];
            this.hasPsychiatricCertificate = _data["hasPsychiatricCertificate"];
            this.hasNarcologicalCertificate = _data["hasNarcologicalCertificate"];
            if (Array.isArray(_data["maritalStatus"])) {
                this.maritalStatus = [] as any;
                for (let item of _data["maritalStatus"])
                    this.maritalStatus!.push(item);
            }
            this.dontShowFromAgency = _data["dontShowFromAgency"];
            this.vacancySortBy = _data["vacancySortBy"];
            if (Array.isArray(_data["liveInOuts"])) {
                this.liveInOuts = [] as any;
                for (let item of _data["liveInOuts"])
                    this.liveInOuts!.push(item);
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(item);
            }
            if (Array.isArray(_data["workingSkills"])) {
                this.workingSkills = [] as any;
                for (let item of _data["workingSkills"])
                    this.workingSkills!.push(item);
            }
            if (Array.isArray(_data["workplaces"])) {
                this.workplaces = [] as any;
                for (let item of _data["workplaces"])
                    this.workplaces!.push(item);
            }
            if (Array.isArray(_data["educations"])) {
                this.educations = [] as any;
                for (let item of _data["educations"])
                    this.educations!.push(item);
            }
            this.hasDriverLicense = _data["hasDriverLicense"];
            this.hasCar = _data["hasCar"];
            if (Array.isArray(_data["nannySubTypes"])) {
                this.nannySubTypes = [] as any;
                for (let item of _data["nannySubTypes"])
                    this.nannySubTypes!.push(item);
            }
            this.hasChildren = _data["hasChildren"];
            if (Array.isArray(_data["childrenCounts"])) {
                this.childrenCounts = [] as any;
                for (let item of _data["childrenCounts"])
                    this.childrenCounts!.push(item);
            }
            if (Array.isArray(_data["workingExperienceAges"])) {
                this.workingExperienceAges = [] as any;
                for (let item of _data["workingExperienceAges"])
                    this.workingExperienceAges!.push(item);
            }
            this.canWorkWithDisabled = _data["canWorkWithDisabled"];
            this.childrenCount = _data["childrenCount"];
            if (Array.isArray(_data["nurseSubTypes"])) {
                this.nurseSubTypes = [] as any;
                for (let item of _data["nurseSubTypes"])
                    this.nurseSubTypes!.push(item);
            }
            if (Array.isArray(_data["diagnoses"])) {
                this.diagnoses = [] as any;
                for (let item of _data["diagnoses"])
                    this.diagnoses!.push(item);
            }
            if (Array.isArray(_data["diagnosesExperience"])) {
                this.diagnosesExperience = [] as any;
                for (let item of _data["diagnosesExperience"])
                    this.diagnosesExperience!.push(item);
            }
            if (Array.isArray(_data["housekeeperSubTypes"])) {
                this.housekeeperSubTypes = [] as any;
                for (let item of _data["housekeeperSubTypes"])
                    this.housekeeperSubTypes!.push(item);
            }
            if (Array.isArray(_data["cleanTools"])) {
                this.cleanTools = [] as any;
                for (let item of _data["cleanTools"])
                    this.cleanTools!.push(item);
            }
            if (Array.isArray(_data["petCareSubTypes"])) {
                this.petCareSubTypes = [] as any;
                for (let item of _data["petCareSubTypes"])
                    this.petCareSubTypes!.push(item);
            }
            if (Array.isArray(_data["animalTypes"])) {
                this.animalTypes = [] as any;
                for (let item of _data["animalTypes"])
                    this.animalTypes!.push(item);
            }
            if (Array.isArray(_data["tutorSubTypes"])) {
                this.tutorSubTypes = [] as any;
                for (let item of _data["tutorSubTypes"])
                    this.tutorSubTypes!.push(item);
            }
            if (Array.isArray(_data["teachingAges"])) {
                this.teachingAges = [] as any;
                for (let item of _data["teachingAges"])
                    this.teachingAges!.push(item);
            }
            this.anyTeachingMusics = _data["anyTeachingMusics"];
            this.anyTeachingPhysicalCultures = _data["anyTeachingPhysicalCultures"];
            this.anyTeachingSubjects = _data["anyTeachingSubjects"];
            this.anyTeachingArts = _data["anyTeachingArts"];
            this.anyTeachingLanguages = _data["anyTeachingLanguages"];
            if (Array.isArray(_data["teachingMusics"])) {
                this.teachingMusics = [] as any;
                for (let item of _data["teachingMusics"])
                    this.teachingMusics!.push(item);
            }
            if (Array.isArray(_data["teachingPhysicalCultures"])) {
                this.teachingPhysicalCultures = [] as any;
                for (let item of _data["teachingPhysicalCultures"])
                    this.teachingPhysicalCultures!.push(item);
            }
            if (Array.isArray(_data["teachingSubjects"])) {
                this.teachingSubjects = [] as any;
                for (let item of _data["teachingSubjects"])
                    this.teachingSubjects!.push(item);
            }
            if (Array.isArray(_data["teachingArts"])) {
                this.teachingArts = [] as any;
                for (let item of _data["teachingArts"])
                    this.teachingArts!.push(item);
            }
            if (Array.isArray(_data["teachingLanguages"])) {
                this.teachingLanguages = [] as any;
                for (let item of _data["teachingLanguages"])
                    this.teachingLanguages!.push(item);
            }
            if (Array.isArray(_data["cookSubTypes"])) {
                this.cookSubTypes = [] as any;
                for (let item of _data["cookSubTypes"])
                    this.cookSubTypes!.push(item);
            }
            if (Array.isArray(_data["cookDuties"])) {
                this.cookDuties = [] as any;
                for (let item of _data["cookDuties"])
                    this.cookDuties!.push(item);
            }
            if (Array.isArray(_data["cookKitchens"])) {
                this.cookKitchens = [] as any;
                for (let item of _data["cookKitchens"])
                    this.cookKitchens!.push(item);
            }
            if (Array.isArray(_data["cookFeatures"])) {
                this.cookFeatures = [] as any;
                for (let item of _data["cookFeatures"])
                    this.cookFeatures!.push(item);
            }
            if (Array.isArray(_data["cookEducations"])) {
                this.cookEducations = [] as any;
                for (let item of _data["cookEducations"])
                    this.cookEducations!.push(item);
            }
            if (Array.isArray(_data["driverSubTypes"])) {
                this.driverSubTypes = [] as any;
                for (let item of _data["driverSubTypes"])
                    this.driverSubTypes!.push(item);
            }
            if (Array.isArray(_data["carUsageOptions"])) {
                this.carUsageOptions = [] as any;
                for (let item of _data["carUsageOptions"])
                    this.carUsageOptions!.push(item);
            }
            if (Array.isArray(_data["babyCarSeatOptions"])) {
                this.babyCarSeatOptions = [] as any;
                for (let item of _data["babyCarSeatOptions"])
                    this.babyCarSeatOptions!.push(item);
            }
            if (Array.isArray(_data["driverNannyDuties"])) {
                this.driverNannyDuties = [] as any;
                for (let item of _data["driverNannyDuties"])
                    this.driverNannyDuties!.push(item);
            }
            if (Array.isArray(_data["driverDuties"])) {
                this.driverDuties = [] as any;
                for (let item of _data["driverDuties"])
                    this.driverDuties!.push(item);
            }
            if (Array.isArray(_data["driverEducations"])) {
                this.driverEducations = [] as any;
                for (let item of _data["driverEducations"])
                    this.driverEducations!.push(item);
            }
            if (Array.isArray(_data["carTypes"])) {
                this.carTypes = [] as any;
                for (let item of _data["carTypes"])
                    this.carTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminSeoConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workType"] = this.workType;
        if (Array.isArray(this.searchTexts)) {
            data["searchTexts"] = [];
            for (let item of this.searchTexts)
                data["searchTexts"].push(item);
        }
        data["fuzzySearchStrictMode"] = this.fuzzySearchStrictMode;
        data["salary"] = this.salary;
        data["salaryConditionType"] = this.salaryConditionType;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.partsOfDay)) {
            data["partsOfDay"] = [];
            for (let item of this.partsOfDay)
                data["partsOfDay"].push(item);
        }
        data["searchRadius"] = this.searchRadius;
        data["originLat"] = this.originLat;
        data["originLng"] = this.originLng;
        data["hasAudioMessage"] = this.hasAudioMessage;
        data["yearExperience"] = this.yearExperience;
        data["workStartDate"] = this.workStartDate ? this.workStartDate.toISOString() : undefined as any;
        if (Array.isArray(this.workingTerms)) {
            data["workingTerms"] = [];
            for (let item of this.workingTerms)
                data["workingTerms"].push(item);
        }
        if (Array.isArray(this.ageGroups)) {
            data["ageGroups"] = [];
            for (let item of this.ageGroups)
                data["ageGroups"].push(item);
        }
        data["notSmoke"] = this.notSmoke;
        data["canSwimWell"] = this.canSwimWell;
        data["isKashrut"] = this.isKashrut;
        data["requireLiveInCaregiverProgram"] = this.requireLiveInCaregiverProgram;
        data["canRelocate"] = this.canRelocate;
        data["withPhoto"] = this.withPhoto;
        data["rightToWork"] = this.rightToWork;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["policeCheck"] = this.policeCheck;
        data["resumeSortBy"] = this.resumeSortBy;
        data["canWorkUnderVideoSurveillance"] = this.canWorkUnderVideoSurveillance;
        data["hasMedicalBook"] = this.hasMedicalBook;
        data["hasMedicalTests"] = this.hasMedicalTests;
        data["hasPsychiatricCertificate"] = this.hasPsychiatricCertificate;
        data["hasNarcologicalCertificate"] = this.hasNarcologicalCertificate;
        if (Array.isArray(this.maritalStatus)) {
            data["maritalStatus"] = [];
            for (let item of this.maritalStatus)
                data["maritalStatus"].push(item);
        }
        data["dontShowFromAgency"] = this.dontShowFromAgency;
        data["vacancySortBy"] = this.vacancySortBy;
        if (Array.isArray(this.liveInOuts)) {
            data["liveInOuts"] = [];
            for (let item of this.liveInOuts)
                data["liveInOuts"].push(item);
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item);
        }
        if (Array.isArray(this.workingSkills)) {
            data["workingSkills"] = [];
            for (let item of this.workingSkills)
                data["workingSkills"].push(item);
        }
        if (Array.isArray(this.workplaces)) {
            data["workplaces"] = [];
            for (let item of this.workplaces)
                data["workplaces"].push(item);
        }
        if (Array.isArray(this.educations)) {
            data["educations"] = [];
            for (let item of this.educations)
                data["educations"].push(item);
        }
        data["hasDriverLicense"] = this.hasDriverLicense;
        data["hasCar"] = this.hasCar;
        if (Array.isArray(this.nannySubTypes)) {
            data["nannySubTypes"] = [];
            for (let item of this.nannySubTypes)
                data["nannySubTypes"].push(item);
        }
        data["hasChildren"] = this.hasChildren;
        if (Array.isArray(this.childrenCounts)) {
            data["childrenCounts"] = [];
            for (let item of this.childrenCounts)
                data["childrenCounts"].push(item);
        }
        if (Array.isArray(this.workingExperienceAges)) {
            data["workingExperienceAges"] = [];
            for (let item of this.workingExperienceAges)
                data["workingExperienceAges"].push(item);
        }
        data["canWorkWithDisabled"] = this.canWorkWithDisabled;
        data["childrenCount"] = this.childrenCount;
        if (Array.isArray(this.nurseSubTypes)) {
            data["nurseSubTypes"] = [];
            for (let item of this.nurseSubTypes)
                data["nurseSubTypes"].push(item);
        }
        if (Array.isArray(this.diagnoses)) {
            data["diagnoses"] = [];
            for (let item of this.diagnoses)
                data["diagnoses"].push(item);
        }
        if (Array.isArray(this.diagnosesExperience)) {
            data["diagnosesExperience"] = [];
            for (let item of this.diagnosesExperience)
                data["diagnosesExperience"].push(item);
        }
        if (Array.isArray(this.housekeeperSubTypes)) {
            data["housekeeperSubTypes"] = [];
            for (let item of this.housekeeperSubTypes)
                data["housekeeperSubTypes"].push(item);
        }
        if (Array.isArray(this.cleanTools)) {
            data["cleanTools"] = [];
            for (let item of this.cleanTools)
                data["cleanTools"].push(item);
        }
        if (Array.isArray(this.petCareSubTypes)) {
            data["petCareSubTypes"] = [];
            for (let item of this.petCareSubTypes)
                data["petCareSubTypes"].push(item);
        }
        if (Array.isArray(this.animalTypes)) {
            data["animalTypes"] = [];
            for (let item of this.animalTypes)
                data["animalTypes"].push(item);
        }
        if (Array.isArray(this.tutorSubTypes)) {
            data["tutorSubTypes"] = [];
            for (let item of this.tutorSubTypes)
                data["tutorSubTypes"].push(item);
        }
        if (Array.isArray(this.teachingAges)) {
            data["teachingAges"] = [];
            for (let item of this.teachingAges)
                data["teachingAges"].push(item);
        }
        data["anyTeachingMusics"] = this.anyTeachingMusics;
        data["anyTeachingPhysicalCultures"] = this.anyTeachingPhysicalCultures;
        data["anyTeachingSubjects"] = this.anyTeachingSubjects;
        data["anyTeachingArts"] = this.anyTeachingArts;
        data["anyTeachingLanguages"] = this.anyTeachingLanguages;
        if (Array.isArray(this.teachingMusics)) {
            data["teachingMusics"] = [];
            for (let item of this.teachingMusics)
                data["teachingMusics"].push(item);
        }
        if (Array.isArray(this.teachingPhysicalCultures)) {
            data["teachingPhysicalCultures"] = [];
            for (let item of this.teachingPhysicalCultures)
                data["teachingPhysicalCultures"].push(item);
        }
        if (Array.isArray(this.teachingSubjects)) {
            data["teachingSubjects"] = [];
            for (let item of this.teachingSubjects)
                data["teachingSubjects"].push(item);
        }
        if (Array.isArray(this.teachingArts)) {
            data["teachingArts"] = [];
            for (let item of this.teachingArts)
                data["teachingArts"].push(item);
        }
        if (Array.isArray(this.teachingLanguages)) {
            data["teachingLanguages"] = [];
            for (let item of this.teachingLanguages)
                data["teachingLanguages"].push(item);
        }
        if (Array.isArray(this.cookSubTypes)) {
            data["cookSubTypes"] = [];
            for (let item of this.cookSubTypes)
                data["cookSubTypes"].push(item);
        }
        if (Array.isArray(this.cookDuties)) {
            data["cookDuties"] = [];
            for (let item of this.cookDuties)
                data["cookDuties"].push(item);
        }
        if (Array.isArray(this.cookKitchens)) {
            data["cookKitchens"] = [];
            for (let item of this.cookKitchens)
                data["cookKitchens"].push(item);
        }
        if (Array.isArray(this.cookFeatures)) {
            data["cookFeatures"] = [];
            for (let item of this.cookFeatures)
                data["cookFeatures"].push(item);
        }
        if (Array.isArray(this.cookEducations)) {
            data["cookEducations"] = [];
            for (let item of this.cookEducations)
                data["cookEducations"].push(item);
        }
        if (Array.isArray(this.driverSubTypes)) {
            data["driverSubTypes"] = [];
            for (let item of this.driverSubTypes)
                data["driverSubTypes"].push(item);
        }
        if (Array.isArray(this.carUsageOptions)) {
            data["carUsageOptions"] = [];
            for (let item of this.carUsageOptions)
                data["carUsageOptions"].push(item);
        }
        if (Array.isArray(this.babyCarSeatOptions)) {
            data["babyCarSeatOptions"] = [];
            for (let item of this.babyCarSeatOptions)
                data["babyCarSeatOptions"].push(item);
        }
        if (Array.isArray(this.driverNannyDuties)) {
            data["driverNannyDuties"] = [];
            for (let item of this.driverNannyDuties)
                data["driverNannyDuties"].push(item);
        }
        if (Array.isArray(this.driverDuties)) {
            data["driverDuties"] = [];
            for (let item of this.driverDuties)
                data["driverDuties"].push(item);
        }
        if (Array.isArray(this.driverEducations)) {
            data["driverEducations"] = [];
            for (let item of this.driverEducations)
                data["driverEducations"].push(item);
        }
        if (Array.isArray(this.carTypes)) {
            data["carTypes"] = [];
            for (let item of this.carTypes)
                data["carTypes"].push(item);
        }
        return data;
    }
}

export interface IAdminSeoConditionDto {
    workType: WorkType;
    searchTexts: string[] | undefined;
    fuzzySearchStrictMode: boolean | undefined;
    salary: number | undefined;
    salaryConditionType: SalaryConditionType | undefined;
    sortOrder: SortOrder | undefined;
    partsOfDay: number[] | undefined;
    searchRadius: number | undefined;
    originLat: number | undefined;
    originLng: number | undefined;
    hasAudioMessage: boolean | undefined;
    yearExperience: number | undefined;
    workStartDate: Date | undefined;
    workingTerms: number[] | undefined;
    ageGroups: number[] | undefined;
    notSmoke: boolean | undefined;
    canSwimWell: boolean | undefined;
    isKashrut: boolean | undefined;
    requireLiveInCaregiverProgram: boolean | undefined;
    canRelocate: boolean | undefined;
    withPhoto: boolean | undefined;
    rightToWork: boolean | undefined;
    languages: number[] | undefined;
    policeCheck: boolean | undefined;
    resumeSortBy: ResumeSortBy | undefined;
    canWorkUnderVideoSurveillance: boolean | undefined;
    hasMedicalBook: boolean | undefined;
    hasMedicalTests: boolean | undefined;
    hasPsychiatricCertificate: boolean | undefined;
    hasNarcologicalCertificate: boolean | undefined;
    maritalStatus: number[] | undefined;
    dontShowFromAgency: boolean | undefined;
    vacancySortBy: VacancySortBy | undefined;
    liveInOuts: number[] | undefined;
    employments: number[] | undefined;
    workingSkills: number[] | undefined;
    workplaces: number[] | undefined;
    educations: number[] | undefined;
    hasDriverLicense: boolean | undefined;
    hasCar: boolean | undefined;
    nannySubTypes: number[] | undefined;
    hasChildren: boolean | undefined;
    childrenCounts: number[] | undefined;
    workingExperienceAges: number[] | undefined;
    canWorkWithDisabled: boolean | undefined;
    childrenCount: number | undefined;
    nurseSubTypes: number[] | undefined;
    diagnoses: number[] | undefined;
    diagnosesExperience: number[] | undefined;
    housekeeperSubTypes: number[] | undefined;
    cleanTools: number[] | undefined;
    petCareSubTypes: number[] | undefined;
    animalTypes: number[] | undefined;
    tutorSubTypes: number[] | undefined;
    teachingAges: number[] | undefined;
    anyTeachingMusics: boolean | undefined;
    anyTeachingPhysicalCultures: boolean | undefined;
    anyTeachingSubjects: boolean | undefined;
    anyTeachingArts: boolean | undefined;
    anyTeachingLanguages: boolean | undefined;
    teachingMusics: number[] | undefined;
    teachingPhysicalCultures: number[] | undefined;
    teachingSubjects: number[] | undefined;
    teachingArts: number[] | undefined;
    teachingLanguages: number[] | undefined;
    cookSubTypes: number[] | undefined;
    cookDuties: number[] | undefined;
    cookKitchens: number[] | undefined;
    cookFeatures: number[] | undefined;
    cookEducations: number[] | undefined;
    driverSubTypes: number[] | undefined;
    carUsageOptions: number[] | undefined;
    babyCarSeatOptions: number[] | undefined;
    driverNannyDuties: number[] | undefined;
    driverDuties: number[] | undefined;
    driverEducations: number[] | undefined;
    carTypes: number[] | undefined;
}

export enum SalaryConditionType {
    LessThanOrEqual = 0,
    GreaterThanOrEqualTo = 1,
}

export enum SortOrder {
    Undefined = 0,
    Descending = 1,
    Ascending = 2,
}

export enum ResumeSortBy {
    Activity = "Activity",
    Experience = "Experience",
    Cost = "Cost",
    Distance = "Distance",
    Age = "Age",
    Relevance = "Relevance",
}

export enum VacancySortBy {
    Activity = "Activity",
    Cost = "Cost",
    Distance = "Distance",
    Relevance = "Relevance",
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class AdminSeoCatalogDetailsDto extends AdminSeoPageDetailsBaseDto implements IAdminSeoCatalogDetailsDto {

    constructor(data?: IAdminSeoCatalogDetailsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AdminSeoCatalogDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoCatalogDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdminSeoCatalogDetailsDto extends IAdminSeoPageDetailsBaseDto {
}

export class AdminSeoCatalogSelectorsDto implements IAdminSeoCatalogSelectorsDto {
    catalogId!: number;
    workType!: WorkType;
    url!: string | undefined;
    selectors!: AdminSeoCatalogSelectorItemDto[];

    constructor(data?: IAdminSeoCatalogSelectorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.selectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogId = _data["catalogId"];
            this.workType = _data["workType"];
            this.url = _data["url"];
            if (Array.isArray(_data["selectors"])) {
                this.selectors = [] as any;
                for (let item of _data["selectors"])
                    this.selectors!.push(AdminSeoCatalogSelectorItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminSeoCatalogSelectorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoCatalogSelectorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogId"] = this.catalogId;
        data["workType"] = this.workType;
        data["url"] = this.url;
        if (Array.isArray(this.selectors)) {
            data["selectors"] = [];
            for (let item of this.selectors)
                data["selectors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminSeoCatalogSelectorsDto {
    catalogId: number;
    workType: WorkType;
    url: string | undefined;
    selectors: AdminSeoCatalogSelectorItemDto[];
}

export class AdminSeoCatalogSelectorItemDto implements IAdminSeoCatalogSelectorItemDto {
    selectorId!: number;
    cityId!: number;
    cityName!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    isModified!: boolean;
    searchResultsCount!: number;
    updateDate!: Date | undefined;

    constructor(data?: IAdminSeoCatalogSelectorItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectorId = _data["selectorId"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.isModified = _data["isModified"];
            this.searchResultsCount = _data["searchResultsCount"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminSeoCatalogSelectorItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoCatalogSelectorItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectorId"] = this.selectorId;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["isModified"] = this.isModified;
        data["searchResultsCount"] = this.searchResultsCount;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminSeoCatalogSelectorItemDto {
    selectorId: number;
    cityId: number;
    cityName: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    isModified: boolean;
    searchResultsCount: number;
    updateDate: Date | undefined;
}

export class SeoChangeEntryDto implements ISeoChangeEntryDto {
    id!: number;
    action!: SeoChangeAction;
    changedBy!: string | undefined;
    changedByName!: string | undefined;
    changedAt!: Date;
    changesJson!: string;

    constructor(data?: ISeoChangeEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.changedBy = _data["changedBy"];
            this.changedByName = _data["changedByName"];
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : undefined as any;
            this.changesJson = _data["changesJson"];
        }
    }

    static fromJS(data: any): SeoChangeEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeoChangeEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["changedBy"] = this.changedBy;
        data["changedByName"] = this.changedByName;
        data["changedAt"] = this.changedAt ? this.changedAt.toISOString() : undefined as any;
        data["changesJson"] = this.changesJson;
        return data;
    }
}

export interface ISeoChangeEntryDto {
    id: number;
    action: SeoChangeAction;
    changedBy: string | undefined;
    changedByName: string | undefined;
    changedAt: Date;
    changesJson: string;
}

export enum SeoChangeAction {
    Undefined = "Undefined",
    Created = "Created",
    DraftCreated = "DraftCreated",
    Updated = "Updated",
    DraftPublished = "DraftPublished",
    Disabled = "Disabled",
    Activated = "Activated",
    Deleted = "Deleted",
    DraftDeleted = "DraftDeleted",
    Restored = "Restored",
}

export enum AdminSeoEntityRoute {
    Undefined = "Undefined",
    Selectors = "Selectors",
    Catalogs = "Catalogs",
}

export class SelectorSearchResultDto implements ISelectorSearchResultDto {
    selectorId!: number;
    catalogId!: number | undefined;
    metaTitle!: string;

    constructor(data?: ISelectorSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectorId = _data["selectorId"];
            this.catalogId = _data["catalogId"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): SelectorSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectorId"] = this.selectorId;
        data["catalogId"] = this.catalogId;
        data["metaTitle"] = this.metaTitle;
        return data;
    }
}

export interface ISelectorSearchResultDto {
    selectorId: number;
    catalogId: number | undefined;
    metaTitle: string;
}

export class AdminSeoDuplicatesCheckRequestDto implements IAdminSeoDuplicatesCheckRequestDto {
    condition!: AdminSeoConditionDto;
    cityId!: number | undefined;

    constructor(data?: IAdminSeoDuplicatesCheckRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.condition = new AdminSeoConditionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.condition = _data["condition"] ? AdminSeoConditionDto.fromJS(_data["condition"]) : new AdminSeoConditionDto();
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): AdminSeoDuplicatesCheckRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoDuplicatesCheckRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["cityId"] = this.cityId;
        return data;
    }
}

export interface IAdminSeoDuplicatesCheckRequestDto {
    condition: AdminSeoConditionDto;
    cityId: number | undefined;
}

export abstract class AdminSeoPageSaveBaseDto implements IAdminSeoPageSaveBaseDto {
    saveAsDraft!: boolean;
    url!: string | undefined;
    oldUrl!: string | undefined;
    data!: SeoData;
    condition!: AdminSeoConditionDto;
    isPriority!: boolean;
    priorityOrder!: number;
    countLinksToIssue!: number;
    isLinkingDisabled!: boolean;
    isDisabled!: boolean;
    medianHourlySalaryEnabled!: boolean;

    constructor(data?: IAdminSeoPageSaveBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = new SeoData();
            this.condition = new AdminSeoConditionDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saveAsDraft = _data["saveAsDraft"];
            this.url = _data["url"];
            this.oldUrl = _data["oldUrl"];
            this.data = _data["data"] ? SeoData.fromJS(_data["data"]) : new SeoData();
            this.condition = _data["condition"] ? AdminSeoConditionDto.fromJS(_data["condition"]) : new AdminSeoConditionDto();
            this.isPriority = _data["isPriority"];
            this.priorityOrder = _data["priorityOrder"];
            this.countLinksToIssue = _data["countLinksToIssue"];
            this.isLinkingDisabled = _data["isLinkingDisabled"];
            this.isDisabled = _data["isDisabled"];
            this.medianHourlySalaryEnabled = _data["medianHourlySalaryEnabled"];
        }
    }

    static fromJS(data: any): AdminSeoPageSaveBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AdminSeoPageSaveBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveAsDraft"] = this.saveAsDraft;
        data["url"] = this.url;
        data["oldUrl"] = this.oldUrl;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["isPriority"] = this.isPriority;
        data["priorityOrder"] = this.priorityOrder;
        data["countLinksToIssue"] = this.countLinksToIssue;
        data["isLinkingDisabled"] = this.isLinkingDisabled;
        data["isDisabled"] = this.isDisabled;
        data["medianHourlySalaryEnabled"] = this.medianHourlySalaryEnabled;
        return data;
    }
}

export interface IAdminSeoPageSaveBaseDto {
    saveAsDraft: boolean;
    url: string | undefined;
    oldUrl: string | undefined;
    data: SeoData;
    condition: AdminSeoConditionDto;
    isPriority: boolean;
    priorityOrder: number;
    countLinksToIssue: number;
    isLinkingDisabled: boolean;
    isDisabled: boolean;
    medianHourlySalaryEnabled: boolean;
}

export class AdminSeoSelectorSaveDto extends AdminSeoPageSaveBaseDto implements IAdminSeoSelectorSaveDto {
    cityId!: number;

    constructor(data?: IAdminSeoSelectorSaveDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cityId = _data["cityId"];
        }
    }

    static override fromJS(data: any): AdminSeoSelectorSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoSelectorSaveDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminSeoSelectorSaveDto extends IAdminSeoPageSaveBaseDto {
    cityId: number;
}

export class AdminSeoCatalogSaveDto extends AdminSeoPageSaveBaseDto implements IAdminSeoCatalogSaveDto {
    replaceModified!: boolean;

    constructor(data?: IAdminSeoCatalogSaveDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.replaceModified = _data["replaceModified"];
        }
    }

    static override fromJS(data: any): AdminSeoCatalogSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSeoCatalogSaveDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["replaceModified"] = this.replaceModified;
        super.toJSON(data);
        return data;
    }
}

export interface IAdminSeoCatalogSaveDto extends IAdminSeoPageSaveBaseDto {
    replaceModified: boolean;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}